import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  serverTimestamp,
  query,
  where
} from "firebase/firestore";
import {
  useNavigate
} from "react-router-dom";
import { db } from "../../firebase";
import {
  createPurchaseOrder, calculateLandedCost, fetchRecentPOHistory, getItemRateHistory
} from "../../pages/services/purchase/purchaseOrderService";
import QuickCreateVendor  from "../quickcreate/forms/QuickCreateVendor";   // ✅ NEW
import QuickCreateModal   from "../quickcreate/QuickCreateModal";           // ✅ NEW

export default function VendorAssignmentModal({

  

  open,
  onClose,
  purchaseRequest

}) {

  const [vendors, setVendors] = useState([]);
    const navigate =
    useNavigate();

  const [vendorId, setVendorId] = useState("");

  const [deliveryDate, setDeliveryDate] = useState("");

  const [priority, setPriority] = useState("normal");

  const [transport, setTransport] = useState("");

  const [remarks, setRemarks] = useState("");

  const [loadingVendors,  setLoadingVendors]  = useState(false);
  const [showVendorQuick, setShowVendorQuick] = useState(false); // ✅ NEW

  useEffect(() => {
    fetchVendors();
  }, []);

  useEffect(() => {
    if (open && purchaseRequest?.vendor_id) {
      setVendorId(purchaseRequest.vendor_id);
    }
  }, [open, purchaseRequest, vendors]); // vendors dependency add karo

  // Merged items — same item_id ki qty add ho jaaye
  const mergedItems = React.useMemo(() => {
    const map = {};
    (purchaseRequest?.items || []).forEach(item => {
      const key = item.item_id || item.item_name;
      if (!key) return;
      if (map[key]) {
        map[key].qty += Number(item.qty || 0);
      } else {
        map[key] = {
          ...item,
          qty: Number(item.qty || 0),
        };
      }
    });
    return Object.values(map);
  }, [purchaseRequest]);

  // ── Rate Breakdown (reference only) ──────────────────────────────────────
  // This screen has never asked for a rate — the actual `rate` field stays
  // 0 here and is entered fresh at GRN (comment above: "rate nahi — GRN pe
  // hoga", CORE_RULES §6). "Quoted Rate" below is a SEPARATE, optional
  // field for Manager-side vendor comparison BEFORE approval — it feeds
  // base_rate/landed cost only, never the PO's own `rate`.
  const [itemRateInputs, setItemRateInputs] = useState({}); // { [item_id||item_name]: {...} }
  const [freightAmount,  setFreightAmount]  = useState("");

  // Lowest-Rate Suggestion — same source (purchase_orders history) and
  // same reference-only display as CreateDirectPO.js. Fetched once when
  // the modal opens, matched per-item client-side.
  const [poHistory,        setPoHistory]        = useState([]);
  const [openHistoryKey,   setOpenHistoryKey]    = useState(null);

  useEffect(() => {
    if (!open) return;
    const defaults = {};
    mergedItems.forEach(item => {
      const key = item.item_id || item.item_name;
      defaults[key] = { quoted_rate: "", discount_type: "percent", discount_value: "", gst_percent: "18" };
    });
    setItemRateInputs(defaults);
    setFreightAmount("");
    setOpenHistoryKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, purchaseRequest]);

  useEffect(() => {
    if (!open) return;
    const loadHistory = async () => {
      const history = await fetchRecentPOHistory(purchaseRequest?.company_id || "");
      setPoHistory(history);
    };
    loadHistory();
  }, [open, purchaseRequest?.company_id]);

  const updateItemRateInput = (key, field, value) => {
    setItemRateInputs(prev => ({ ...prev, [key]: { ...prev[key], [field]: value } }));
  };

  // Same calculateLandedCost() the backend uses at creation — what's shown
  // here is guaranteed identical to what gets stored.
  const landedItems = calculateLandedCost(
    mergedItems.map(item => {
      const key    = item.item_id || item.item_name;
      const inputs = itemRateInputs[key] || {};
      return {
        ...item,
        qty:            Number(item.qty || 0),
        base_rate:      Number(inputs.quoted_rate || 0),
        discount_type:  inputs.discount_type || "percent",
        discount_value: Number(inputs.discount_value || 0),
        gst_percent:    Number(inputs.gst_percent || 0),
      };
    }),
    Number(freightAmount || 0)
  );
  const landedGrandTotal = landedItems.reduce((sum, item) => sum + (item.landed_total || 0), 0);

  

  const fetchVendors = async () => {

    try {

      setLoadingVendors(true);

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const snap = await getDocs(
        query(
          collection(db, "vendors"),
          where("company_id", "==", user.company_id || "")
        )
      );

      const list = snap.docs.map((doc) => ({

        id: doc.id,

        ...doc.data()

      }));

      setVendors(list);

    } catch (error) {

      console.error(
        "Vendor fetch failed",
        error
      );

    } finally {

      setLoadingVendors(false);

    }
  };

  const handleClose = () => {

    setVendorId("");

    setDeliveryDate("");

    setPriority("normal");

    setTransport("");

    setRemarks("");

    onClose();
  };

  if (!open) return null;

  const handleCreatePO = async () => {

  try {

    const selectedVendor = vendors.find(
      (v) => v.id === vendorId
    );

    // VALIDATIONS

    if (!selectedVendor) {

      alert("Please select vendor");

      return;
    }

    if (!deliveryDate) {

      alert("Please select delivery date");

      return;
    }

    // FINAL PAYLOAD

    // Rate Breakdown fields merged in — base_rate/discount/gst are
    // reference-only, `rate` itself is left exactly as before (0/absent,
    // GRN's own entry) — see the comment above itemRateInputs.
    const payloadItems = mergedItems.map(item => {
      const key    = item.item_id || item.item_name;
      const inputs = itemRateInputs[key] || {};
      return {
        ...item,
        base_rate:      Number(inputs.quoted_rate || 0),
        discount_type:  inputs.discount_type || "percent",
        discount_value: Number(inputs.discount_value || 0),
        gst_percent:    Number(inputs.gst_percent || 0),
      };
    });

  // Merge rates into items
    const payload = {
      company_id:                    purchaseRequest?.company_id || "",
      vendor_id:                     selectedVendor.id || "",
      vendor_name:                   selectedVendor.vendor_name || selectedVendor.name || "",
      delivery_date:                 deliveryDate,
      priority,
      transport,
      remarks,
      source_purchase_request_id:    purchaseRequest?.id || "",
      freight_amount:                Number(freightAmount || 0),
      items:                         payloadItems,  // ✅ rate nahi — GRN pe hoga
    };

    // SERVICE CALL

    const response =
      await createPurchaseOrder(payload);

    console.log(
      "PURCHASE ORDER RESPONSE",
      response
    );

    // SUCCESS

if (response.success) {

  // =====================================
  // UPDATE PURCHASE REQUEST STATUS
  // =====================================

  await updateDoc(

    doc(
      db,
      "purchase_requests",
      purchaseRequest.id
    ),

    {

      procurement_status:
        "po_generated",

      vendor_id:
        selectedVendor.id || "",

      vendor_name:
        selectedVendor.vendor_name ||
        selectedVendor.name ||
        "",

      vendor_assigned_at:
        serverTimestamp(),

      po_id:
        response.po_id || "",

      po_number:
        response.po_number || ""

    }
  );

  alert(
    `PO Created Successfully

PO: ${response.po_number}

Vendor Assigned Successfully`
  );

  handleClose();

  navigate(
    "/purchase-orders",
    {
      replace: true,

      state: {

        highlight_po_id:
          response.po_id,

        po_created: true,

        po_number:
          response.po_number
      }
    }
  );

} else {

  alert(
    "Failed to create purchase order"
  );
}

  } catch (error) {

    console.error(
      "PO creation failed",
      error
    );

    alert(
      "Something went wrong"
    );
  }
};

  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">

      <div className="w-full max-w-5xl bg-white rounded-3xl shadow-2xl overflow-hidden animate-[fadeIn_.2s_ease]">

        {/* HEADER */}

        <div className="flex items-center justify-between px-6 py-5 border-b bg-gradient-to-r from-slate-50 to-white">

          <div>

            <h2 className="text-2xl font-black text-slate-800">
              Assign Vendor
            </h2>

            <p className="text-sm text-slate-500 mt-1">
              Create purchase order from procurement request
            </p>

          </div>

          <button
            onClick={handleClose}
            className="text-sm px-4 py-2 rounded-xl bg-slate-100 hover:bg-slate-200 transition"
          >
            Close
          </button>

        </div>

        {/* BODY */}

        <div className="p-6 space-y-5 max-h-[75vh] overflow-y-auto">

          {/* PURCHASE INFO */}

          <div className="bg-slate-50 rounded-2xl p-4 border border-slate-200">

            <div className="text-sm text-slate-500">
              Purchase Request
            </div>

            <div className="text-lg font-bold text-slate-800 mt-1">
              {purchaseRequest?.items?.length || 0} Items
            </div>

          </div>

          {/* VENDOR */}

          <div>

            <label className="text-sm font-semibold text-slate-700 block mb-2">
              Vendor
            </label>

            {/* ✅ Dropdown + Quick Add button */}
            <div className="flex gap-2 items-center">
              <select
                value={vendorId}
                onChange={(e) => setVendorId(e.target.value)}
                className="flex-1 border rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-cyan-500"
              >
                <option value="">
                  {loadingVendors ? "Loading Vendors..." : "Select Vendor"}
                </option>
                {vendors.map((vendor) => (
                  <option key={vendor.id} value={vendor.id}>
                    {vendor.vendor_name || vendor.name || "Unnamed Vendor"}
                  </option>
                ))}
              </select>

              {/* ✅ + button */}
              <button
                type="button"
                onClick={() => setShowVendorQuick(true)}
                title="Add new vendor"
                className="flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center border border-dashed border-indigo-300 text-indigo-500 bg-indigo-50 hover:bg-indigo-100 cursor-pointer transition"
              >
                <svg width="16" height="16" viewBox="0 0 14 14" fill="none">
                  <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            </div>

            {/* ✅ QuickCreate Vendor Modal */}
            <QuickCreateModal
              open={showVendorQuick}
              onClose={() => setShowVendorQuick(false)}
              title="Add New Vendor"
            >
              <QuickCreateVendor
                companyId={
                  JSON.parse(localStorage.getItem("user") || "{}").company_id || ""
                }
                onCreated={(newVendor) => {
                  // ✅ vendors list mein add karo + auto-select
                  setVendors(prev => [...prev, newVendor]);
                  setVendorId(newVendor.id);
                  setShowVendorQuick(false);
                }}
                onCancel={() => setShowVendorQuick(false)}
              />
            </QuickCreateModal>

          </div>

          {/* DELIVERY DATE */}

          <div>

            <label className="text-sm font-semibold text-slate-700 block mb-2">
              Delivery Date
            </label>

            <input
              type="date"
              value={deliveryDate}
              onChange={(e) =>
                setDeliveryDate(e.target.value)
              }
              className="w-full border rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-cyan-500"
            />

          </div>

          {/* PRIORITY */}

          <div>

            <label className="text-sm font-semibold text-slate-700 block mb-2">
              Priority
            </label>

            <select
              value={priority}
              onChange={(e) =>
                setPriority(e.target.value)
              }
              className="w-full border rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-cyan-500"
            >

              <option value="normal">
                Normal
              </option>

              <option value="urgent">
                Urgent
              </option>

              <option value="critical">
                Critical
              </option>

            </select>

          </div>

          {/* TRANSPORT */}

          <div>

            <label className="text-sm font-semibold text-slate-700 block mb-2">
              Transport
            </label>

            <input
              type="text"
              value={transport}
              onChange={(e) =>
                setTransport(e.target.value)
              }
              placeholder="Transport details"
              className="w-full border rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-cyan-500"
            />

          </div>

          {/* REMARKS */}

          <div>

            <label className="text-sm font-semibold text-slate-700 block mb-2">
              Remarks
            </label>

            <textarea
              rows={4}
              value={remarks}
              onChange={(e) =>
                setRemarks(e.target.value)
              }
              placeholder="Additional procurement notes..."
              className="w-full border rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-cyan-500"
            />

          </div>

          {/* REQUEST ITEMS + RATE BREAKDOWN (reference only) */}

          <div>

            <div className="text-sm font-semibold text-slate-700 mb-1">
              Items & Rate Breakdown
            </div>
            <p className="text-xs text-slate-400 mb-3">
              "Quoted Rate" is optional — for comparing this vendor's quote only. The
              PO's actual Rate is always entered fresh at GRN, unchanged from before.
            </p>

            <div className="border rounded-2xl overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-slate-50 text-xs font-semibold text-slate-500 uppercase">
                      <th className="text-left px-4 py-2 min-w-[240px]">Item</th>
                      <th className="text-right px-3 py-2 w-24">Qty</th>
                      <th className="text-right px-3 py-2 w-28">Quoted Rate (₹)</th>
                      <th className="text-center px-3 py-2 w-36">Discount</th>
                      <th className="text-right px-3 py-2 w-20">GST %</th>
                      <th className="text-right px-3 py-2 w-28">Landed Rate</th>
                      <th className="text-right px-4 py-2 w-32">Landed Total</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {mergedItems.map((item, index) => {
                      const key    = item.item_id || item.item_name;
                      const inputs = itemRateInputs[key] || {};
                      const landed = landedItems[index] || {};
                      return (
                        <tr key={`${key}_${index}`} className="bg-white hover:bg-slate-50 transition align-top">
                          <td className="px-4 py-2.5">
                            <div className="text-sm font-semibold text-slate-700">{item.item_name}</div>
                            <div className="text-xs text-slate-400">{item.item_code || "-"}</div>
                            {/* Lowest-Rate Suggestion — reference only, never
                                auto-fills Quoted Rate/Discount/GST above. */}
                            {(() => {
                              const history = getItemRateHistory(poHistory, item);
                              if (history.length === 0) return null;
                              const isOpen = openHistoryKey === key;
                              return (
                                <div className="mt-1">
                                  <button type="button"
                                    onClick={() => setOpenHistoryKey(isOpen ? null : key)}
                                    className="text-xs text-teal-600 hover:text-teal-800 font-medium whitespace-nowrap">
                                    📊 {history.length} past rate{history.length > 1 ? "s" : ""} — from ₹{history[0].landed_rate.toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                                  </button>
                                  {isOpen && (
                                    <div className="mt-1 border border-slate-200 rounded-lg bg-slate-50 p-2 space-y-1 min-w-[220px]">
                                      {history.map((h, i) => (
                                        <div key={i} className={`flex items-center justify-between text-xs px-2 py-1 rounded ${i === 0 ? "bg-teal-50 font-semibold text-teal-800" : "text-slate-600"}`}>
                                          <span className="truncate">
                                            {h.vendor_name} · {h.created_at?.toDate ? h.created_at.toDate().toLocaleDateString("en-IN") : "—"}
                                            {i === 0 && <span className="ml-1 text-teal-600">(lowest)</span>}
                                          </span>
                                          <span className="whitespace-nowrap ml-2">₹{h.landed_rate.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              );
                            })()}
                          </td>
                          <td className="px-3 py-2.5 text-right text-sm font-bold text-slate-800 whitespace-nowrap">
                            {Number(item.qty || 0)} {item.unit || item.uom || "nos"}
                          </td>
                          <td className="px-3 py-2.5">
                            <input type="number" min="0" step="0.01" value={inputs.quoted_rate || ""}
                              onChange={e => updateItemRateInput(key, "quoted_rate", e.target.value)}
                              placeholder="0"
                              className="w-full min-w-[100px] px-2 py-1.5 border border-slate-300 rounded-lg text-sm text-right outline-none focus:ring-2 focus:ring-cyan-400" />
                          </td>
                          <td className="px-3 py-2.5">
                            <div className="flex gap-1">
                              <select
                                value={inputs.discount_type || "percent"}
                                onChange={e => updateItemRateInput(key, "discount_type", e.target.value)}
                                className="px-1.5 py-1.5 border border-slate-300 rounded-lg text-xs outline-none bg-white shrink-0">
                                <option value="percent">%</option>
                                <option value="flat">₹</option>
                              </select>
                              {/* Width follows the mode — % tops out at 100
                                  (3 digits), flat ₹ can run into 6 digits
                                  (subtotal-sized). Same reasoning as
                                  CreateDirectPO.js's Discount column. */}
                              <input type="number" min="0"
                                max={inputs.discount_type === "flat" ? undefined : 100}
                                step="0.01" value={inputs.discount_value || ""}
                                onChange={e => updateItemRateInput(key, "discount_value", e.target.value)}
                                placeholder="0"
                                className={`px-2 py-1.5 border border-slate-300 rounded-lg text-sm text-right outline-none focus:ring-2 focus:ring-cyan-400 ${
                                  inputs.discount_type === "flat" ? "w-[110px]" : "w-[70px]"
                                }`} />
                            </div>
                          </td>
                          <td className="px-3 py-2.5">
                            <input type="number" min="0" max="100" step="0.01" value={inputs.gst_percent ?? ""}
                              onChange={e => updateItemRateInput(key, "gst_percent", e.target.value)}
                              placeholder="18"
                              className="w-full min-w-[70px] px-2 py-1.5 border border-slate-300 rounded-lg text-sm text-right outline-none focus:ring-2 focus:ring-cyan-400" />
                          </td>
                          <td className="px-3 py-2.5 text-right text-sm font-semibold text-teal-700 whitespace-nowrap">
                            ₹{(landed.landed_rate || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                          </td>
                          <td className="px-4 py-2.5 text-right text-sm font-semibold text-teal-700 whitespace-nowrap">
                            ₹{(landed.landed_total || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* ✅ Grand Total GRN pe hoga — PO pe nahi */}
            </div>

          </div>

          {/* FREIGHT (one flat amount for the whole PO) — reference only */}
          <div>
            <label className="text-sm font-semibold text-slate-700 block mb-2">
              Freight / Transport (₹, whole PO) — optional
            </label>
            <div className="flex items-end gap-4 flex-wrap">
              <input type="number" min="0" step="0.01" value={freightAmount}
                onChange={e => setFreightAmount(e.target.value)}
                placeholder="0"
                className="w-48 border rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-cyan-500" />
              <div>
                <p className="text-xs text-slate-400">Total Landed Cost (all items, ref. only)</p>
                <p className="text-lg font-bold text-teal-700">
                  ₹{landedGrandTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </p>
              </div>
            </div>
            <p className="text-xs text-slate-400 mt-1">
              Split across items proportionally — reference only, never changes the GRN rate.
            </p>
          </div>

        </div>

        {/* FOOTER */}

        <div className="flex justify-end gap-3 px-6 py-5 border-t bg-slate-50">

          <button
            onClick={handleClose}
            className="px-5 py-3 rounded-2xl border border-slate-300 text-slate-700 hover:bg-slate-100 transition"
          >
            Cancel
          </button>

          <button
  onClick={handleCreatePO}
  disabled={
    !vendorId ||
    !deliveryDate
  }
            className={`px-6 py-3 rounded-2xl text-white font-semibold transition ${
              !vendorId || !deliveryDate
                ? "bg-slate-300 cursor-not-allowed"
                : "bg-gradient-to-r from-indigo-600 to-cyan-500 hover:scale-[1.02]"
            }`}
          >
            Create PO
          </button>

        </div>

      </div>

    </div>

  );
}